/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Delegated_Access_InvalidInputs */

const en_error_delegated_access_invalid = /** @type {(inputs: Error_Delegated_Access_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The token asks for more than you may delegate.`)
};

/**
* | output |
* | --- |
* | "The token asks for more than you may delegate." |
*
* @param {Error_Delegated_Access_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_delegated_access_invalid = /** @type {((inputs?: Error_Delegated_Access_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Delegated_Access_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_delegated_access_invalid(inputs)
});